import React, {useEffect, useState} from "react"
import PropTypes from "prop-types";

import {getImagePromiseFromLayout} from "../../misc/getCanvasImageFromLayout";
import LoadingSpinner from "../ui/loadingSpinner";
import {useIsMounted} from "../../misc/helperHooks";
import {createFakeLayout} from "../appLayout";

const LayoutNavigationItem = (props) => {

  const {keyType, layout, handleLayoutItemClick, isMobile, imageOnly} = props;
  const type = layout.layoutTypes[keyType];
  const [thumbnailUrl, setThumbnailUrl] = useState(
    layout.layoutThumbnails && layout.layoutThumbnails[keyType] ? layout.layoutThumbnails[keyType] : ""
  );
  const isMounted = useIsMounted();

  useEffect(() => {
    if (!thumbnailUrl) {
      const getLayoutThumbnail = async () => {
        const fakeLayout = layout.type === type ? layout : createFakeLayout(layout, keyType, layout.scene);
        if (layout.type !== type) {
          const currentState = layout.getActiveFeaturesAsObject(true, false, true); // get current selected features
          await fakeLayout.selectLayout(type, layout.type, currentState, layout.scene, null, true);
        }
        getImagePromiseFromLayout(fakeLayout)
          .then(response => {
            // console.log("response", response);
            if (isMounted()) {
              setThumbnailUrl(response);
            }
          })

      }
      getLayoutThumbnail();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (imageOnly) {
    return <img src={thumbnailUrl} className="layout-image" alt="item.type"/>
  }

  if (isMobile) {
    const layoutItemWidth = (window.innerWidth / 4 - 10);
    const persentageOfWidth = layoutItemWidth * 100 / 720;
    const height = 405 * persentageOfWidth / 100;

    return (
      <li className={"menu-layout__list-item"
      + (type === layout.type ? " menu-layout__list-item--active" : "")}
          onClick={() => handleLayoutItemClick(type)}
      >
        <div className="menu-layout__list-item-image" style={{minHeight: height}}>
          {thumbnailUrl ? <img src={thumbnailUrl} alt="item.type"/> : <LoadingSpinner/>}
        </div>
      </li>
    )
  }

  return (
    <li className={"layout-list__item" + (type === layout.type ? " active" : "")}
        data-index={type}
        onClick={() => handleLayoutItemClick ? handleLayoutItemClick(type) : null}
        style={{backgroundImage: `url(${thumbnailUrl})`}}>
      {thumbnailUrl ? null : <LoadingSpinner/>}
    </li>
  );
}

LayoutNavigationItem.propTypes = {
  keyType: PropTypes.string.isRequired,
  layout: PropTypes.object.isRequired,
  handleLayoutItemClick: PropTypes.func,
  isMobile: PropTypes.bool,
  imageOnly: PropTypes.bool,
}

export default LayoutNavigationItem
